import _ from "underscore";
import DisabledNodesParentNodeRenderer from "../tree/DisabledNodesParentNodeRenderer";

export default function ArchivedProjectsParentNodeRenderer(tree, selectorFilter, selectionHelper)
{
    DisabledNodesParentNodeRenderer.call(this, tree, selectorFilter, selectionHelper);
}

ArchivedProjectsParentNodeRenderer.prototype = _.create(DisabledNodesParentNodeRenderer.prototype, {
    labelMessageKey: function()
    {
        return "cp_selector.archived_projects_parent_node_label"
    }
});



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/customerProjectSelector/ArchivedProjectsParentNodeRenderer.js